<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">

                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <span>Testimonials</span>
                    </div>
                    <div class="font-bold">Testimonials List</div>
                </div>

                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap">
                        <h1 class="text-base md:text-lg font-semibold mb-4">Testimonials List</h1>
                        <div class="flex items-center flex-wrap">
                            <div class="w-full sm:w-auto mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Type:</div>
                                <select v-model="filterByType" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="partner">Partner Testimonial</option>
                                    <option value="student">Student Testimonial</option>
                                </select>
                            </div>
                            <div
                                class="w-full sm:w-auto ml-0 sm:ml-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Testimonial Type:</div>
                                <select v-model="filterByTestimonialType" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="text">Text Testimonial</option>
                                    <option value="video">Video Testimonial</option>
                                </select>
                            </div>
                            <div class="w-full sm:w-auto ml-0 sm:ml-8 mb-4">
                                <search @on-search="onSearch" class-list="px-4 h-8"></search>
                            </div>
                            <div class="flex justify-start items-center flex-wrap ml-0 sm:ml-8 mb-4">
                                <div v-if="hasPermission('testimonial-create')" @click.stop="createModal = true"
                                    class="flex items-center bg-ternary hover:bg-white border-ternary border px-4 py-2 rounded-lg cursor-pointer text-white hover:text-ternary">
                                    <icon-plus class="w-4 h-4"></icon-plus>
                                    <span class="text-xs ml-2">Create Testimonial</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col" v-if="$apollo.queries.testimonials.loading">
                        <table-shimmer
                            :titleHeaders="['#', 'Name', 'Type', 'Designation', 'Testimonial Type', 'Testimonial', 'Status', 'Actions']"
                            :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.testimonials.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No testimonials found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Name</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Type</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Designation</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Testimonial Type</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Testimonial</th>
                                                <!-- <th scope="col" class="px-6 py-2 text-gray-400">Company Logo</th> -->
                                                <th scope="col" class="px-6 py-2 text-gray-400">Status</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="flex items-center">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img class="h-12 w-12 rounded-lg object-contain"
                                                                :src="getSrcFile(item.thumbnail)" alt="">
                                                        </div>
                                                        <div class="flex-grow flex flex-col mr-4">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span @click.stop="viewItem(item)"
                                                                    class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{
                                                                        item.name }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400">{{ item.email }}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ getType(item.type) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.designation }}</td>
                                                <td class="whitespace-nowrap px-6 py-2 capitalize">{{
                                                    item.testimonial_type }}</td>
                                                <td class="px-6 py-2 truncate-3">{{ item.testimonial }}</td>
                                                <!-- <td class="px-6 py-2">
                                                    <img class="h-12 w-12 rounded-lg object-contain" :src="getSrcFile(item.company_logo)" alt="">
                                                </td> -->
                                                <td class="whitespace-nowrap px-6 py-2 text-center">
                                                    <div>{{ getStatus(item.status) }}</div>
                                                    <div v-if="item.note">({{ item.note }})</div>
                                                </td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('testimonial-show')"
                                                            @click.stop="viewItem(item)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                        <div v-if="hasPermission('testimonial-edit') && showEditButton(item.status) && role == 'partner'"
                                                            @click.stop="editItem(item)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-pen
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-pen>
                                                        </div>
                                                        <div v-if="hasPermission('testimonial-delete')"
                                                            @click.stop="deleteItem(item.token)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-trash
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-trash>
                                                        </div>

                                                        <div v-if="hasPermission('testimonial-approval') && isShowApproveReject(item.status)"
                                                            @click.stop="approveTestimonial(item.token, true)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-approve
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                                                        </div>
                                                        <div v-if="hasPermission('testimonial-approval') && isShowApproveReject(item.status)"
                                                            @click.stop="rejectTestimonial(item.token)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-reject
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="showAddNote" :title="`Add Your Note`" @close="closeAddNote">
                            <div class="flex flex-col">
                                <label for="note" class="px-8 mt-4 text-sm ml-1">Note</label>
                                <div class="h-32 px-8 rounded-xl mt-2">
                                    <textarea v-model="note"
                                        class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                                </div>
                                <div class="flex justify-end mt-4 mr-8">
                                    <div @click.stop="addNoteOk"
                                        class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        OK</div>
                                </div>
                            </div>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="createModal" :title="`Create Testimonial`" @close="closeModal">
                            <create @created="onCreated" @close="closeModal"></create>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="editModal" :title="`Edit Testimonial`" @close="closeModal">
                            <edit @updated="onUpdated" @close="closeModal" :selected-item="selectedItem"></edit>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="isViewItem" :title="`View Testimonial`" height="" @close="closeModal">
                            <view-testimonial class="text-left" :item="selectedItem"
                                @close="closeModal"></view-testimonial>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isLoading">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>

<script>
import IconEye from "../../components/icons/IconEye.vue";
import IconPen from "../../components/icons/IconPen.vue";
import IconTrash from "../../components/icons/IconTrash.vue";
import IconPlus from "../../components/icons/IconPlus.vue";
import IconApprove from "../../components/icons/IconApprove.vue";
import IconReject from "../../components/icons/IconReject.vue";
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
import TableShimmer from '../../components/shared/TableShimmer.vue';
import Create from "./create.vue";
import Edit from "./edit.vue";
import ViewTestimonial from "./view.vue";
import Search from "../../components/shared/search.vue";
export default {
    name: "testimonials-index",
    components: {
        IconEye,
        IconPen,
        IconTrash,
        IconPlus,
        IconApprove,
        IconReject,
        Pagination,
        TableShimmer,
        Create,
        Edit,
        ViewTestimonial,
        Search,
    },
    data() {
        return {
            testimonials: [],
            first: 10,
            page: 1,
            createModal: false,
            editModal: false,
            isViewItem: false,
            modalTitle: "",
            selectedItem: null,
            partnersList: [],
            entities: [],
            isLoading: false,
            note: "",
            showAddNote: false,
            selectedToken: null,
            filterByType: "",
            filterByTestimonialType: "",
            searchText: "",
        };
    },
    watch: {
        searchText() {
            this.page = 1;
        },
        testimonials(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
        filterByType() {
            this.page = 1;
        },
        filterByTestimonialType() {
            this.page = 1;
        },
    },
    computed: {
        items() {
            return this.testimonials.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.testimonials.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        filteredEntities() {
            return this.entities.data;
        },
    },
    apollo: {
        testimonials() {
            return {
                query: gql`query GetAllPartnerTestimonials($first: Int!, $page: Int!, $filter_by_type: String, $filter_by_testimonial_type: String, $search: String) {
                    testimonials(first: $first, page: $page, filter_by_type: $filter_by_type, filter_by_testimonial_type: $filter_by_testimonial_type, search: $search) {
                        error
                        error_code
                        message
                        data {
                            token
                            type
                            organization_name
                            name
                            designation
                            email
                            phone
                            testimonial
                            thumbnail
                            company_logo
                            testimonial_type
                            upload_type
                            video_testimonial_url
                            video_testimonial_file_url
                            dont_reveal
                            status
                            note
                            created_at
                            updated_at
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        filter_by_type: this.filterByType,
                        filter_by_testimonial_type: this.filterByTestimonialType,
                        search: this.searchText,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        onSearch(searchText) {
            this.searchText = searchText;
        },
        formattedDate(date) {
            if (date) {
                const parsedDate = new Date(date);
                return parsedDate.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).replace(/\//g, '-');
            } else {
                return "";
            }
        },
        setPage(page) {
            this.page = page;
        },
        closeModal() {
            this.createModal = false;
            this.editModal = false;
            this.isViewItem = false;
            this.modalTitle = "";
            this.selectedItem = null;
        },
        showToast(message = '') {
            this.$apollo.queries.testimonials.refetch();
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: message
            })
            this.closeModal();
        },
        onCreated() {
            this.showToast('Testimonial Created Successfully');
        },
        editItem(item) {
            this.selectedItem = item;
            this.editModal = true;
        },
        async deleteItem(token) {
            let error_msg = null;
            this.$swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {

                    this.isLoading = true;

                    const DELETE_MUTATION = gql`
                        mutation DeleteTestimonial($token: String!) {
                            deleteTestimonial(token: $token) {
                                error
                                message
                            }
                        }
                    `;

                    try {
                        await this.$apollo.mutate({
                            mutation: DELETE_MUTATION,
                            variables: {
                                token: token,
                            }
                        }).then((data) => {
                            if (data.data.deleteTestimonial.error) {
                                error_msg = data.data.deleteTestimonial.message;
                            }
                        }).catch((error) => {
                            error_msg = error.message;
                        })

                    } catch (error) {
                        error_msg = error.message || "Please try again.";
                    }

                    if (error_msg === null) {
                        this.showToast('Your testimonial has been deleted.');
                    } else {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: error_msg,
                        }).then((result) => {
                            if (result.value || result.dismiss) {
                                error_msg = null
                            }
                        })
                    }

                    this.isLoading = false;

                }
            })
        },
        onUpdated() {
            this.showToast('Testimonial Updated Successfully');
        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        viewItem(item) {
            this.selectedItem = item;
            this.isViewItem = true;
        },
        getType(type) {
            if (type == 'student') {
                return "Student Testimonial";
            } else {
                return "Partner Testimonial";
            }
        },
        getSrcFile(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
        getStatus(status) {
            if (status === true) {
                return "Approved";
            } else if (status === false) {
                return "Rejected";
            } else {
                return "Not verified yet";
            }
        },
        showEditButton(status) {
            if (status === false) {
                return true;
            } else {
                return false;
            }
        },
        isShowApproveReject(status) {
            if (this.role == 'admin' || this.role == 'superadmin') {
                if (status === null) {
                    return true;
                } else {
                    return false
                }
            } else {
                return false;
            }
        },
        approveTestimonial(token) {
            this.approveOrRejectTestimonial(token, true);
        },
        rejectTestimonial(token) {
            this.selectedToken = token;
            this.showAddNote = true;
        },
        closeAddNote() {
            this.showAddNote = false;
            this.note = "";
            this.selectedToken = null;
        },
        addNoteOk() {
            this.showAddNote = false;
            this.approveOrRejectTestimonial(this.selectedToken, false);
        },
        async approveOrRejectTestimonial(token, status) {

            this.isLoading = true;

            const APPROVE_OR_REJECT_TESTIMONIAL = gql`
                mutation ApproveOrRejectTestimonial($token: String!, $status: Boolean!, $note: String) {
                    approveOrRejectTestimonial(token: $token, status: $status, note: $note) {
                        error
                        message
                    }
                }
            `;

            let error_msg = null;
            let success_msg = null;

            try {
                await this.$apollo.mutate({
                    mutation: APPROVE_OR_REJECT_TESTIMONIAL,
                    variables: {
                        token: token,
                        status: status,
                        note: this.note,
                    }
                }).then((data) => {
                    if (data.data.approveOrRejectTestimonial.error) {
                        error_msg = data.data.approveOrRejectTestimonial.message;
                    } else {
                        success_msg = data.data.approveOrRejectTestimonial.message;
                    }
                }).catch((error) => {
                    console.error(error)
                })
            } catch (error) {
                error_msg = error.message || "Failed to authenticate, try later.";
            }

            if (error_msg === null) {
                this.showToast(success_msg);
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error_msg,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        error_msg = null
                    }
                })
            }

            this.note = "";
            this.isLoading = false;

        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.truncate-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>